// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__9C5vW","success":"Pill_success__yXgki","warning":"Pill_warning__T4m7u","danger":"Pill_danger__M6oqk"};